import React from 'react';
import { ServicePageLayout } from './ServicePageLayout';
export function RestaurantWebsiteDublin() {
  const content = <div className="space-y-6 text-white/80" data-id="element-838">
      <p data-id="element-839">
        Dublin's food scene is competitive. From the bustling streets of Temple
        Bar to the cozy neighborhoods of Ranelagh and Rathmines, hungry
        customers are searching online for their next meal. If your restaurant
        doesn't have a mouth-watering website, you're leaving tables empty.
      </p>

      <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-840">
        More Than Just a Menu
      </h2>
      <p data-id="element-841">
        A great restaurant website does more than just list your dishes. It
        sells the <em data-id="element-842">experience</em>. We design websites that capture the
        atmosphere of your venue, whether it's a casual burger joint or fine
        dining. High-quality images, easy-to-read menus, and simple reservation
        buttons are standard in our designs.
      </p>

      <h3 className="text-xl font-bold text-[#c9a84c] mt-6 mb-2" data-id="element-843">
        Essential Features for Dublin Restaurants
      </h3>
      <ul className="list-disc pl-6 space-y-2" data-id="element-844">
        <li data-id="element-845">
          <strong data-id="element-846">Mobile Menu:</strong> No more PDF downloads. We build
          responsive menus that look perfect on phones.
        </li>
        <li data-id="element-847">
          <strong data-id="element-848">Reservation Integration:</strong> Link directly to OpenTable,
          ResDiary, or a simple WhatsApp booking button.
        </li>
        <li data-id="element-849">
          <strong data-id="element-850">Google Maps:</strong> Help tourists and locals find you easily
          with integrated maps.
        </li>
        <li data-id="element-851">
          <strong data-id="element-852">Social Proof:</strong> Display your best TripAdvisor or Google
          Reviews to build trust.
        </li>
      </ul>

      <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-853">
        Get More Bookings for €249
      </h2>
      <p data-id="element-854">
        Margins in hospitality are tight. You don't need a €3,000 website to
        fill your seats. Our
        <strong data-id="element-855"> €249 Restaurant Package</strong> gives you everything you need
        to look professional and get found online. Fast, reliable, and beautiful
        — just like your service.
      </p>
    </div>;
  const faqs = [{
    q: 'Can I update the menu myself?',
    a: 'Yes! With our included MagicPatterns Hobby Plan, you can use AI to update menu items and prices instantly without needing a developer.'
  }, {
    q: 'Do you support online ordering?',
    a: 'We can link to your Deliveroo, Uber Eats, or Just Eat pages, or set up a simple order-via-WhatsApp system.'
  }, {
    q: 'Is hosting included?',
    a: 'Yes, we include 1 year of fast, reliable hosting so your site is always online when hungry customers are searching.'
  }, {
    q: 'Can you help with photos?',
    a: "While we don't take photos, we can help you select the best stock images or guide you on what shots work best for the website."
  }];
  const relatedServices = [{
    title: 'Hotels',
    href: '/services/hotel-website-ireland'
  }, {
    title: 'Barbers',
    href: '/services/barber-website-dublin'
  }, {
    title: 'Electricians',
    href: '/services/electrician-website-dublin'
  }, {
    title: 'Trades',
    href: '/services/trades-website-dublin'
  }];
  return <ServicePageLayout title="Restaurant Website Design Dublin | Get More Bookings" metaDescription="Beautiful, affordable website design for Dublin restaurants. Mobile menus, reservation links, and SEO ready. Launch package just €249." heroTitle="Restaurant Website Design Dublin" heroSubtitle="Turn hungry searchers into booked tables with a stunning website that showcases your food and atmosphere." content={content} faqs={faqs} relatedServices={relatedServices} data-id="element-856" />;
}